import React from 'react';
import { siteConfig } from '../config/siteConfig';
import ScrollingTitle from '../components/ScrollingTitle/ScrollingTitle';
import './Page.css';

const AlexanderKammelBiography = () => {
  const { alexanderKammelBiography } = siteConfig;

  return (
    <div className="alexander-kammel-page">
      <ScrollingTitle lines={alexanderKammelBiography.title.lines} />
      
      <div className="page-container alexander-kammel-content">
        <div className="page-content">
          <div className="content-section alexander-kammel-main">
            <div className="alexander-kammel-text-columns">
              <div className="alexander-kammel-left-column">
                <p>{alexanderKammelBiography.content.leftColumn}</p>
              </div>
              <div className="alexander-kammel-right-column">
                <p>{alexanderKammelBiography.content.rightColumn}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="alexander-kammel-images-section">
        <div className="alexander-kammel-images-container">
          <div className="alexander-kammel-images">
            {alexanderKammelBiography.images.map((image, index) => (
              <div key={index} className="alexander-kammel-image">
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlexanderKammelBiography; 